module.exports = __webpack_public_path__ + "img/SCCY1.1e4b420d.jpg";